import ReportContent from '@app/components/reports/components/report-content';
import SimpleBarChart from '@shared/components/chart/simple-bar-chart';
import Text from '@shared/components/content/text';
import { ChartConfig, ChartLegend } from '@shared/components/ui/chart';
import { useCCFReportResult } from '../../ccf-report-result-context';

export default function Scope2BySite() {
  const {
    result: { scope2 },
  } = useCCFReportResult();

  const chartData = scope2.emissionsBySite?.map((site) => {
    const emissions_data = site.categories.map((category) => {
      const key = category.name.split(' ')[0].toLowerCase();
      return {
        [key]: category.emissionsTonnes,
      };
    });

    return {
      site: site.siteName,
      ...emissions_data.reduce((acc, curr) => ({ ...acc, ...curr }), {}),
    };
  });

  const chartConfig = {
    electricity: {
      label: 'Electricity',
      color: 'var(--chart-2)',
      unit: 'tCO2e',
    },
    heat: {
      label: 'Heating and steam',
      color: 'var(--chart-3)',
      unit: 'tCO2e',
    },
  } satisfies ChartConfig;
  return (
    <ReportContent variant="full">
      <>
        <Text variant="h3">Total emissions per site by category</Text>
        <div className="mb-2 flex space-x-9">
          {Object.entries(chartConfig).map((category, idx) => {
            return (
              <div key={idx}>
                <ChartLegend
                  name={category[1].label}
                  color={category[1].color}
                />
              </div>
            );
          })}
        </div>

        <SimpleBarChart
          nameKey="site"
          dataKey=""
          chartData={chartData}
          chartConfig={chartConfig}
          className="h-max max-h-[calc(var(--content-title-height)-20rem)] w-full"
          margin={{ top: 30 }}
          YAxisProps={{
            label: {
              value: 'tCO2e',
              position: 'top',
              offset: 15,
            },
          }}
        />
      </>
    </ReportContent>
  );
}
